import { CostLimitExceededError } from './usageLimitError';

export class AppError extends Error {
  constructor(
    message: string,
    public code?: string,
    public userMessage?: string
  ) {
    super(message);
    this.name = 'AppError';
  }
}

export function handleError(error: unknown): string {
  if (error instanceof CostLimitExceededError) {
    return error.message;
  }
  if (error instanceof AppError) {
    return error.userMessage || error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'An unknown error occurred';
}

export function logError(error: unknown, context?: string): void {
  const message = error instanceof Error ? error.message : String(error);
  const logMessage = context ? `[${context}] ${message}` : message;
  console.error(logMessage, error);
}

